
import React, { useState } from "react";
import { Container, Row, Col, Button,  Input, InputGroup, Modal, ModalHeader, ModalBody, ModalFooter, } from "reactstrap";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CandidateDataInfo from './CandidateListDataInfo'

import { FaBriefcase, FaRegPlusSquare, FaPhoneAlt, FaExternalLinkAlt, FaRegEye } from "react-icons/fa";

const AtsArchiveeCandidates = () => {
    const [CandidateListData, setCandidateListData] = useState(CandidateDataInfo);
    const [selectedCandidates, setselectedCandidates] = useState([]);
    const [expandedJobRows, setExpandedJobRows] = useState(null);

    const [backdrop, setBackdrop] = useState(true);
    const [keyboard, setKeyboard] = useState(true);

    const changeBackdrop = (e) => {
        let { value } = e.target;
        if (value !== 'static') {
        value = JSON.parse(value);
        }
        setBackdrop(value);
    };

    const changeKeyboard = (e) => {
        setKeyboard(e.currentTarget.checked);
    };

    const viewCandidateExperience = (rowData) => {
        return (
            <span className="bg-light px-2 py-1 rounded d-inline-block">
                {rowData.experience} + Years
            </span>
        );
    };

    const viewCandidateDetails = (rowData) => {
        return (
            <Button className="btn btn-light" onClick={ViewCandidateInfoCall}><FaRegEye /></Button>
        )
    }

    const [ViewCandidatePopupShow, setViewCandidatePopupShow] = useState(false);
    
    const ViewCandidateInfoCall = () => { setViewCandidatePopupShow(!ViewCandidatePopupShow); }

    return (
        <React.Fragment>
            <div className="page-content allact-tabs manager-dash">
                <Container fluid>
                    <div className="page-title-box mb-0 recruiter-dashboard actjobsum">
                        <Row>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}> <h1 class="page-title mb-4">Archive Candidates</h1> </Col>
                        </Row>
                        <Card className="mb-3 shadow-md border-0">
                            <Row className="mt-3">
                                <Col xxl={12}>
                                    <DataTable
                                        className="CandidateListTableView"
                                        value={CandidateListData}
                                        dataKey="id"
                                        tableStyle={{ minWidth: "50rem" }}
                                        responsiveLayout="scroll"
                                        selectionMode="checkbox" selection={selectedCandidates}  onSelectionChange={(e) => setselectedCandidates(e.value)}
                                        expandedRows={expandedJobRows} onRowToggle={(e) => setExpandedJobRows(e.data)}
                                    >
                                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                                        <Column expander style={{ width: "3rem" }} />
                                        <Column field="candidate_name" header="Name" />
                                        <Column field="candidate_email" header="Email" />
                                        <Column field="candidate_phone" header="Phone" />
                                        <Column field="experience" header="Experience" body={viewCandidateExperience} />
                                        <Column header="Candidate Details" body={viewCandidateDetails} />
                                        {/* <Column body={viewCandidatesTemplate} header="View" /> */}
                                        <Column field="actionStatus" header="Assigned Tests" />
                                        <Column field="actionStatus" header="Is Selected" />
                                        <Column
                                            header="Action"
                                            body={() => (
                                                <div className="d-flex gap-2">
                                                    <Button color="success" size="sm">
                                                        delete
                                                    </Button>
                                                </div>
                                            )}
                                        />
                                    </DataTable>
                                </Col>
                            </Row>
                        </Card>
                        
                    </div>
                </Container>
            </div>
            <Modal isOpen={ViewCandidatePopupShow} toggle={ViewCandidateInfoCall} size="xl" backdrop={backdrop} keyboard={keyboard}>
                <ModalHeader toggle={ViewCandidateInfoCall}>Bheemaraju Ajay</ModalHeader>
                <ModalBody>
                    <Card title="Candidate Analysis" className="mb-3 shadow-sm border-0">
                        <Row>
                            <Col xxl={3}>First Name</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}></Col>
                        </Row>
                        <Row>
                            <Col xxl={3}>Last Name</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}>Bheemaraju Ajay</Col>
                        </Row>
                        <Row>
                            <Col xxl={3}>Total Experience</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}>0.0</Col>
                        </Row>
                    </Card>

                    <Card title="Contact Info" className="mb-3 shadow-sm border-0">
                        <Row>
                            <Col xxl={3}>Email</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}>ajaybittu605@gmail.com</Col>
                        </Row>
                        <Row>
                            <Col xxl={3}>Phone</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}>9912093252</Col>
                        </Row>
                    </Card>

                    <Card title="Skills" className="mb-3 shadow-sm border-0">
                        <Row>
                            <Col xxl={3}>Skills</Col>
                            <Col xxl={1}>:</Col>
                            <Col xxl={8}>Python, Django,</Col>
                        </Row>
                    </Card>
                </ModalBody>
                <ModalFooter>
                    <Button color="warning" onClick={ViewCandidateInfoCall}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
     )
}

export default AtsArchiveeCandidates;
